// Cart auto-refresh
(() => {
  let timeoutId = null;
  
  const triggerRefresh = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      document.querySelector('cart-drawer-component')?.refresh();
      timeoutId = null;
    }, 800);
  };
  
  const originalFetch = window.fetch;
  
  window.fetch = function(...args) {
    const url = args[0]?.toString() || '';
    
    if (url.includes('add.js') || url.includes('/cart/add')) {
      triggerRefresh();
    }
    
    if (url.includes('change.js') || url.includes('/cart/change')) {
      triggerRefresh();
    }
    
    return originalFetch.apply(this, args);
  };
  
  document.addEventListener('change', () => {
    triggerRefresh();
  });
})();

// Offers page product card variant switcher with Abra price sync
(() => {
  const cardStates = new Map();
  let isUpdating = false;

  function findPriceWrapper(card) {
    return card.querySelector('.stack_price_container')
      || card.querySelector('[data-abra-selector]')
      || card.querySelector('[ref="priceContainer"]');
  }

  function createPriceContainer(card, productHandle, variantId) {
    const swatch = card.querySelector(`.variant_swatch[data-variant-id="${variantId}"]`);
    const hiddenPrice = swatch?.nextElementSibling;
    if (!hiddenPrice?.classList.contains('item_price_stack')) return null;

    const productPrice = card.querySelector('product-price');
    if (!productPrice) return null;

    const el = document.createElement('div');
    el.setAttribute('ref', 'priceContainer');
    el.classList.add('stack_price_container');
    el.setAttribute('data-product-handle', productHandle);
    el.setAttribute('data-variant-id', variantId);
    el.innerHTML = hiddenPrice.innerHTML;
    productPrice.prepend(el);
    return el;
  }

  function keyedPriceContainer(card, productHandle, variantId) {
    const existing = findPriceWrapper(card);
    if (existing) existing.remove();
    return createPriceContainer(card, productHandle, variantId);
  }

  function ensurePriceContainer(card, productHandle, variantId) {
    const existing = findPriceWrapper(card);
    if (existing) {
      existing.setAttribute('data-product-handle', productHandle);
      existing.setAttribute('data-variant-id', variantId);
      return existing;
    }
    return createPriceContainer(card, productHandle, variantId);
  }

  function prepareAllCards(clickedCard) {
    cardStates.forEach((state, cardElement) => {
      if (!document.contains(cardElement)) return;
      if (cardElement === clickedCard) {
        keyedPriceContainer(cardElement, state.productHandle, state.variantId);
      } else {
        ensurePriceContainer(cardElement, state.productHandle, state.variantId);
      }
    });
  }

  function applyCardState(card, productHandle, variantId) {
    const priceWrapper = findPriceWrapper(card);
    const variantSwatches = card.querySelectorAll('.variant_swatch');

    card.setAttribute('data-product-handle', productHandle);
    card.setAttribute('data-variant-id', variantId);

    if (priceWrapper) {
      priceWrapper.setAttribute('data-product-handle', productHandle);
      priceWrapper.setAttribute('data-variant-id', variantId);
    }

    const form = card.querySelector('form');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value !== variantId) idInput.value = variantId;
    }

    variantSwatches.forEach(swatch => {
      swatch.setAttribute('data-product-handle', productHandle);
      const swatchVariantId = swatch.getAttribute('data-variant-id');
      if (swatchVariantId === variantId) {
        swatch.classList.add('active_swatch');
        swatch.setAttribute('aria-checked', 'true');
      } else {
        swatch.classList.remove('active_swatch');
        swatch.setAttribute('aria-checked', 'false');
      }
    });
  }

  function applyAllSavedCards() {
    cardStates.forEach((state, cardElement) => {
      if (document.contains(cardElement)) {
        applyCardState(cardElement, state.productHandle, state.variantId);
      }
    });
  }

  function init() {
    if (isUpdating) return;

    const cards = document.querySelectorAll('product-card[data-product-id]');

    cards.forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const productUrl = link.getAttribute('href');
      const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
      if (!productHandle) return;

      if (!cardStates.has(card)) {
        const activeVariantSwatch = card.querySelector('.variant_swatch.active_swatch');
        const initialVariantId = activeVariantSwatch?.getAttribute('data-variant-id');
        if (initialVariantId) {
          cardStates.set(card, { productHandle, variantId: initialVariantId });
          applyCardState(card, productHandle, initialVariantId);
        }
      }

      const variantSwatches = card.querySelectorAll('.variant_swatch');

      variantSwatches.forEach((swatch) => {
        if (swatch.dataset.abraListenerAttached) return;
        swatch.dataset.abraListenerAttached = 'true';

        swatch.addEventListener('click', function() {
          const variantId = this.getAttribute('data-variant-id');
          const swatchProductHandle = this.getAttribute('data-product-handle') || productHandle;

          isUpdating = true;
          cardStates.set(card, { productHandle: swatchProductHandle, variantId });

          prepareAllCards(card);
          applyAllSavedCards();

          if (window.Abra?.render) {
            window.Abra.render()
              .then(() => {
                prepareAllCards(card);
                applyAllSavedCards();
                return window.Abra.render();
              })
              .then(() => {
                applyAllSavedCards();
                isUpdating = false;
              })
              .catch(() => {
                applyAllSavedCards();
                isUpdating = false;
              });
          } else {
            isUpdating = false;
          }
        });
      });
    });
  }

  let initTimeout;
  function debouncedInit() {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(init, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(debouncedInit).observe(document.body, { childList: true, subtree: true });
})();
